<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'des-critica-despesa') {
            next({ name: 'des-critica-despesa-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'des-critica-despesa') {
            this.$router.push({ name: 'des-critica-despesa-list' });
        }
    },
};
</script>
